module.exports = __webpack_public_path__ + "img/plant_3_mobile.f2fe78ad.webp";